<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Auditoria de Conta</h5>
                            <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="dados">

                            <print-export :printid="modal_name + '_auditoria'">
                                <template v-slot:outros>
                                    <button type="button" class="btn btn-outline-danger ml-1" @click="revertendo = !revertendo" title="Reverter Auditoria" v-if="pode_reverter">
                                        <i class="fa-solid fa-arrow-rotate-left"></i>
                                    </button>
                                </template>
                            </print-export>

                            <div class="alert alert-danger px-2 py-1 mt-3" v-if="revertendo">
                                <strong>Reversão de auditoria.</strong> Marque os itens que deseja reverter e clique em "Reverter Auditoria".
                            </div>
                            
                            <div :id="modal_name + '_auditoria'" class="mt-3">

                                <cabecalho-generico titulo="Auditoria da Conta" />

                                <div class="alert alert-info">
                                    <div>
                                        <div class="lead" v-if="guia && guia.atendimento && guia.atendimento.paciente">
                                            {{ guia.atendimento.paciente.st_nome }}
                                        </div>
                                        #{{ dados.id_guia_auditoria }}
                                        <i class="fa-solid fa-lock-open ml-2" v-if="!dados.fl_encerrada"></i>
                                        <i class="fa-solid fa-lock ml-2" v-else></i>
                                        <span class="ml-3" v-if="dados.usuario">{{ dados.usuario.st_login }}</span>
                                    </div>
                                    <div>
                                        {{ $util.getFormatDate(dados.created_at) }} {{ dados.created_at ? dados.created_at.slice(11,16) : '' }} a
                                        {{ $util.getFormatDate(dados.updated_at) }} {{ dados.updated_at ? dados.updated_at.slice(11,16) : '' }} 
                                    </div>
                                    <div class="small text-muted" v-if="dados.st_observacoes">{{ dados.st_observacoes}}</div>
                                </div>

                                <table class="table table-sm table-hover small">
                                    <thead>
                                        <tr>
                                            <th v-if="revertendo">
                                                <a href="#" @click.prevent="toggle_marcar_todos()" class="card-link">
                                                    <i class="fa-solid fa-square"></i>
                                                </a>
                                            </th>
                                            <th>Código</th>
                                            <th>Descrição</th>
                                            <th class="text-right">Qtde</th>
                                            <th class="text-right">Valor Unitário</th>
                                            <th class="text-right">Valor Total</th>
                                            <th class="text-right">Diferença</th>
                                            <th class="text-center">Justificativa</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, ix) in dados.items" :key="ix" :class="item.diferenca < 0 ? 'table-danger' : (item.diferenca > 0 ? 'table-success' : '')">
                                            <th v-if="revertendo">
                                                <input type="checkbox" v-model="item.reverter" />
                                            </th>
                                            <td>{{ item.st_codigo_anterior }}</td>
                                            <td>{{ item.st_descricao }}</td>
                                            <td class="text-right text-nowrap">
                                                <s class="mr-1" v-if="item.in_qtde_anterior != item.in_qtde_posterior">{{ item.in_qtde_anterior }}</s>
                                                {{ item.in_qtde_posterior }}
                                            </td>
                                            <td class="text-right text-nowrap">
                                                <s class="mr-1" v-if="item.dc_valor_unit_anterior != item.dc_valor_unit_posterior">{{ $util.formatMoeda(item.dc_valor_unit_anterior) }}</s>
                                                {{ $util.formatMoeda(item.dc_valor_unit_posterior) }}
                                            </td>
                                            <td class="text-right text-nowrap">
                                                <s class="mr-1" v-if="item.valor_total_anterior != item.valor_total_posterior">{{ $util.formatMoeda(item.valor_total_anterior) }}</s>
                                                {{ $util.formatMoeda(item.valor_total_posterior) }}
                                            </td>
                                            <td class="text-right text-nowrap">
                                                <span v-if="item.diferenca">
                                                    {{ $util.formatMoeda(item.diferenca) }}
                                                </span>
                                            </td>
                                            <td class="text-center small">{{ item.st_obs }}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th colspan="4">Total</th>
                                            <th class="text-right">
                                                <s class="mr-1" v-if="dados.valor_total_anterior != dados.valor_total_posterior">{{ $util.formatMoeda(dados.valor_total_anterior) }}</s>
                                                {{ $util.formatMoeda(dados.valor_total_posterior) }}
                                            </th>
                                            <th class="text-right">{{ $util.formatMoeda(dados.diferenca) }}</th>
                                            <th></th>
                                        </tr>
                                    </tfoot>
                                </table>

                            </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Fechar</button>
                        <button type="button" class="btn btn-success" @click="reverter_auditoria()" v-if="pode_reverter && revertendo">Reverter Auditoria</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';

export default {
    data() {
        return { 
            dados: null, 
            guia: null, 
            chave: "", 
            revertendo: false, 
        }
    },

    props: [
        'pode_reverter',
    ],

    components: { PrintExport, CabecalhoGenerico },
  
    computed: { 
        modal_name: function() { 
            return `verAuditModal${this.chave}`; 
        }
    },

    methods: { 
        reverter_auditoria () { 
            if ( !this.dados || !this.dados.items || !this.dados.items.some(i => i.reverter) ) { 
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Erro', 
                    detail: 'Nenhum item marcado para reversão.',
                    life: 3000,  
                });
                return; 
            }

            let apg_reverter = _.mapKeys(
                this.dados.items.filter(i => i.reverter)
                   .filter(i => i.model_type == 'App\\azure\\atendimentoProcedimentoGuia'),
                'model_id'
            );

            console.log('apg_reverter', apg_reverter);

            let cpg_reverter = _.mapKeys(
                this.dados.items.filter(i => i.reverter)
                   .filter(i => i.model_type == 'App\\azure\\consumoProcedimentoGuia'),
                'model_id'
            );

            console.log('cpg_reverter', cpg_reverter);

            this.$parent.guia.atendimento_procedimento_guias.forEach(apg => { 
                if ( apg_reverter[apg.id_atendimento_procedimento_guia] ) { 
                    apg.dc_valor = apg_reverter[apg.id_atendimento_procedimento_guia].dc_valor_unit_anterior || 0;
                    apg.in_quantidade = apg_reverter[apg.id_atendimento_procedimento_guia].in_qtde_anterior || 0;
                }

                if ( apg.consumo_procedimentos && apg.consumo_procedimentos.length ) { 
                    apg.consumo_procedimentos.forEach(cpg => { 
                        if ( cpg_reverter[cpg.id_consumo_procedimento_guia] ) { 
                            cpg.dc_valor = cpg_reverter[cpg.id_consumo_procedimento_guia].dc_valor_unit_anterior || 0;
                            cpg.dc_quantidade = cpg_reverter[cpg.id_consumo_procedimento_guia].in_qtde_anterior || 0;
                        }
                    });
                }
            });

            $(`#${this.modal_name}`).modal('hide'); 
        },

        toggle_marcar_todos () { 
            let marcar = this.dados.items.some(i => !i.reverter);
            this.dados.items.forEach(i => i.reverter = marcar);
            this.$forceUpdate();
        },

        imprimir_auditoria () { 

        }, 

        fechar_modal () { 
            $(`#${this.modal_name}`).modal('hide');
        },

        abrir (guia, id_guia_auditoria) { 
            this.revertendo = false; 
            this.guia = _.cloneDeep(guia);
            $(`#${this.modal_name}`).modal('show'); 

            this.$util.load(this, { 
                service: 'guia_auditorias', 
                func: 'show',
                parms: { 
                    id: id_guia_auditoria,
                }, 
                loadTo: res => { 
                    this.dados = res; 
                }
            });
        }
    },

    mounted() { 
        this.chave = this.$util.uuidv4(); 
    }
}
</script>

    